import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

// Floating "back to top" button. Appears after the reader scrolls down.
// Positioned to avoid the other floating UI: mobile = bottom-right (first-order
// banner is hidden there, ShrimpRoom's filter button is bottom-left), and
// tablet/desktop = bottom-left (first-order banner sits bottom-right).
export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="Back to top"
      data-testid="back-to-top-button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed z-40 bottom-20 right-5 sm:left-6 sm:right-auto lg:left-8 lg:bottom-8 h-11 w-11 rounded-full bg-shrimp-green text-white shadow-lg flex items-center justify-center hover:bg-shrimp-text hover:scale-105 transition-all duration-300 ${visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-3 pointer-events-none'}`}
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
};

export default BackToTop;
